// Do not edit this file manually, it is generated by the generate:abilities script
import {
  AbilitiesPermissions,
  type ReadWritePermissions,
  type Resource,
  type ResourceHierarchy,
} from '../types/abilities';
import {
  makeMemberAbility,
  makeOwnerAbility,
  makeScopedMemberAbility,
} from './authorization/actions';

export const ResourceList: Resource[] = [
  'client',
  'vessel',
  'referral',
  'assignment',
  'transaction',
  'balance',
  'financial',
  'settings',
  'task',
];

export const hierarchy: ResourceHierarchy = {
  client: {
    view: [],
    create: [],
    edit: [],
    delete: [],
    children: {
      partnerPayment: {
        view: [],
        create: [],
        edit: [],
        delete: [],
        query: {
          referenceType: {
            eq: 'referral',
          },
        },
        protected: true,
        resource: 'payments',
      },
      supplierPayment: {
        view: [],
        create: [],
        edit: [],
        delete: [],
        query: {
          referenceType: {
            eq: 'supplier',
          },
        },
        protected: true,
        resource: 'payments',
      },
    },
    filters: [
      {
        label: 'client',
        value: 'client.client',
        query: {
          type: {
            eq: 'client',
          },
        },
      },
      {
        label: 'partner',
        value: 'client.partner',
        query: {
          type: {
            eq: 'partner',
          },
        },
      },
      {
        label: 'supplier',
        value: 'client.supplier',
        query: {
          type: {
            eq: 'supplier',
          },
        },
      },
    ],
  },
  vessel: {
    view: [
      {
        resource: 'client',
        action: 1,
      },
    ],
    create: [],
    edit: [],
    delete: [],
    children: {
      syncVesselFromHcg: {
        create: [],
      },
    },
  },
  referral: {
    view: [
      {
        resource: 'client',
        action: 1,
      },
      {
        resource: 'vessel',
        action: 1,
      },
      {
        resource: 'assignment',
        action: 1,
      },
    ],
    create: [],
    edit: [],
    delete: [],
  },
  assignment: {
    view: [
      {
        resource: 'client',
        action: 1,
      },
      {
        resource: 'vessel',
        action: 1,
      },
    ],
    create: [],
    edit: [],
    delete: [],
    children: {
      portCall: {
        view: [],
        create: [],
        edit: [],
        delete: [],
        children: {
          parseCrewList: {
            edit: [],
          },
          parsePassengerList: {
            edit: [],
          },
          port: {
            view: [],
            protected: true,
            resource: 'ports',
          },
          portFilters: {
            view: [],
          },
          syncPortCallFromHcg: {
            create: [],
          },
        },
        protected: true,
      },
      assignmentPayment: {
        view: [],
        create: [],
        edit: [],
        delete: [],
        query: {
          referenceType: {
            eq: 'assignment',
          },
        },
        protected: true,
        resource: 'payments',
      },
      group: {
        view: [],
        create: [],
        edit: [],
        delete: [],
      },
      applyAssignmentTemplate: {
        create: [],
      },
      template: {
        view: [],
        create: [],
        edit: [],
        delete: [],
      },
      AssignmentPDFs: {
        view: [],
      },
      duplicateAssignment: {
        create: [],
      },
      activeAssignmentsCount: {
        view: [],
      },
      arrivingVesselsCount: {
        view: [],
      },
    },
    filters: [
      {
        label: 'active',
        value: 'assignment.activeAssignment',
        query: {
          status: {
            in: ['accepted', 'in_progress', 'finalising'],
          },
        },
      },
    ],
  },
  transaction: {
    view: [],
    create: [],
    edit: [],
    delete: [],
    children: {
      transactionPayment: {
        view: [],
        create: [],
        edit: [],
        delete: [],
        query: {
          referenceType: {
            eq: 'transaction',
          },
        },
        protected: true,
        resource: 'payments',
      },
      officeExpense: {
        view: [],
        create: [],
        query: {
          type: {
            eq: 'office_expense',
          },
        },
        protected: true,
        resource: 'transactions',
      },
      recurringTransaction: {
        view: [],
        create: [],
        edit: [],
        delete: [],
        protected: true,
        resource: 'recurring_transactions',
      },
    },
    filters: [
      {
        label: 'assignment',
        value: 'transactions.assignments',
        query: {
          referenceType: {
            eq: 'assignment_invoice',
          },
        },
      },
    ],
  },
  balance: {
    resource: 'balance_holders',
    scopes: {
      all: {},
      own: {
        query: {
          'balance_holders.kind': 'employee',
          'balance_holders.userId': '$session.userId',
        },
      },
    },
    children: {
      balanceActivation: {
        resource: 'balance_activations',
        protected: true,
        view: {
          scopes: ['own', 'all'],
        },
        scopes: {
          all: {},
          own: {},
        },
      },
      balanceMovement: {
        resource: 'balance_movements',
        protected: true,
        view: {
          scopes: ['own', 'all'],
        },
        scopes: {
          all: {},
          own: {
            query: {
              'balance_movements.holderId': {
                in: {
                  select: 'balance_holders.id',
                  query: {
                    kind: 'employee',
                    userId: '$session.userId',
                  },
                },
              },
            },
          },
        },
      },
    },
    view: {
      scopes: ['own', 'all'],
    },
    create: {
      scopes: ['all'],
    },
  },
  financial: {
    children: {
      clientBalance: {
        view: [],
      },
      outstandingExpenses: {
        view: [],
      },
      income: {
        view: [],
      },
      expenses: {
        view: [],
      },
      cashflow: {
        view: [],
      },
    },
  },
  settings: {
    children: {
      member: {
        view: [],
        create: [],
        edit: [],
        delete: [],
        children: {
          memberImpersonate: {
            view: [],
          },
        },
      },
      role: {
        view: [],
        create: [],
        edit: [],
        delete: [],
      },
      organizationConfig: {
        view: [],
        edit: [],
      },
    },
  },
  task: {
    resource: 'tasks',
    scopes: {
      all: {},
      own: {
        query: {
          'tasks.id': {
            in: {
              select: 'assignees.referenceId',
              query: {
                referenceType: 'task',
                userId: '$session.userId',
              },
            },
          },
        },
      },
    },
    view: {
      scopes: ['own', 'all'],
    },
    edit: {
      scopes: ['own', 'all'],
    },
    create: [],
    delete: {
      scopes: ['all'],
    },
  },
};

export const readWritePermissions: ReadWritePermissions = {
  client: {
    permissions: ['None', 'Read', 'Write'],
    filters: [
      {
        label: 'client',
        value: 'client.client',
        query: {
          type: {
            eq: 'client',
          },
        },
      },
      {
        label: 'partner',
        value: 'client.partner',
        query: {
          type: {
            eq: 'partner',
          },
        },
      },
      {
        label: 'supplier',
        value: 'client.supplier',
        query: {
          type: {
            eq: 'supplier',
          },
        },
      },
    ],
  },
  vessel: {
    permissions: ['None', 'Read', 'Write'],
  },
  referral: {
    permissions: ['None', 'Read', 'Write'],
  },
  assignment: {
    permissions: ['None', 'Read', 'Write'],
    filters: [
      {
        label: 'active',
        value: 'assignment.activeAssignment',
        query: {
          status: {
            in: ['accepted', 'in_progress', 'finalising'],
          },
        },
      },
    ],
  },
  transaction: {
    permissions: ['None', 'Read', 'Write'],
    filters: [
      {
        label: 'assignment',
        value: 'transactions.assignments',
        query: {
          referenceType: {
            eq: 'assignment_invoice',
          },
        },
      },
    ],
  },
  balance: {
    permissions: ['None', 'Read', 'Write'],
  },
  financial: {
    permissions: ['None', 'Read'],
  },
  settings: {
    permissions: ['None', 'Read', 'Write'],
  },
  task: {
    permissions: ['None', 'Read', 'Write'],
  },
};

export const ownerAbility = makeOwnerAbility();

export const activeAssignmentFilterAbility = makeMemberAbility(
  'assignment.activeAssignment',
  AbilitiesPermissions.View,
  true
);
export const assignmentTransactionFilterAbility = makeMemberAbility(
  'transactions.assignments',
  AbilitiesPermissions.View,
  true
);
export const createApplyAssignmentTemplateAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.Create
);
export const createAssignmentAbility = makeMemberAbility('assignment', AbilitiesPermissions.Create);
export const createAssignmentPaymentAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.Create
);
export const createBalanceAbility = makeScopedMemberAbility(
  ['balance.all'],
  AbilitiesPermissions.Create
);
export const createBalanceAllAbility = makeMemberAbility(
  'balance.all',
  AbilitiesPermissions.Create
);
export const createClientFilterAbility = makeMemberAbility(
  'client.client',
  AbilitiesPermissions.Create
);
export const createDuplicateAssignmentAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.Create
);
export const createGroupAbility = makeMemberAbility('assignment', AbilitiesPermissions.Create);
export const createMemberAbility = makeMemberAbility('settings', AbilitiesPermissions.Create);
export const createOfficeExpenseAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Create
);
export const createPartnerFilterAbility = makeMemberAbility(
  'client.partner',
  AbilitiesPermissions.Create
);
export const createPartnerPaymentAbility = makeMemberAbility('client', AbilitiesPermissions.Create);
export const createPortCallAbility = makeMemberAbility('assignment', AbilitiesPermissions.Create);
export const createRecurringTransactionAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Create
);
export const createReferralAbility = makeMemberAbility('referral', AbilitiesPermissions.Create);
export const createRoleAbility = makeMemberAbility('settings', AbilitiesPermissions.Create);
export const createSupplierFilterAbility = makeMemberAbility(
  'client.supplier',
  AbilitiesPermissions.Create
);
export const createSupplierPaymentAbility = makeMemberAbility(
  'client',
  AbilitiesPermissions.Create
);
export const createSyncPortCallFromHcgAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.Create
);
export const createSyncVesselFromHcgAbility = makeMemberAbility(
  'vessel',
  AbilitiesPermissions.Create
);
export const createTaskAbility = makeMemberAbility('task', AbilitiesPermissions.Create);
export const createTemplateAbility = makeMemberAbility('assignment', AbilitiesPermissions.Create);
export const createTransactionAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Create
);
export const createTransactionPaymentAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Create
);
export const createVesselAbility = makeMemberAbility('vessel', AbilitiesPermissions.Create);
export const deleteAssignmentAbility = makeMemberAbility('assignment', AbilitiesPermissions.Delete);
export const deleteAssignmentPaymentAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.Delete
);
export const deleteClientFilterAbility = makeMemberAbility(
  'client.client',
  AbilitiesPermissions.Delete
);
export const deleteGroupAbility = makeMemberAbility('assignment', AbilitiesPermissions.Delete);
export const deleteMemberAbility = makeMemberAbility('settings', AbilitiesPermissions.Delete);
export const deletePartnerFilterAbility = makeMemberAbility(
  'client.partner',
  AbilitiesPermissions.Delete
);
export const deletePartnerPaymentAbility = makeMemberAbility('client', AbilitiesPermissions.Delete);
export const deletePortCallAbility = makeMemberAbility('assignment', AbilitiesPermissions.Delete);
export const deleteRecurringTransactionAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Delete
);
export const deleteReferralAbility = makeMemberAbility('referral', AbilitiesPermissions.Delete);
export const deleteRoleAbility = makeMemberAbility('settings', AbilitiesPermissions.Delete);
export const deleteSupplierFilterAbility = makeMemberAbility(
  'client.supplier',
  AbilitiesPermissions.Delete
);
export const deleteSupplierPaymentAbility = makeMemberAbility(
  'client',
  AbilitiesPermissions.Delete
);
export const deleteTaskAbility = makeScopedMemberAbility(['task.all'], AbilitiesPermissions.Delete);
export const deleteTaskAllAbility = makeMemberAbility('task.all', AbilitiesPermissions.Delete);
export const deleteTemplateAbility = makeMemberAbility('assignment', AbilitiesPermissions.Delete);
export const deleteTransactionAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Delete
);
export const deleteTransactionPaymentAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Delete
);
export const deleteVesselAbility = makeMemberAbility('vessel', AbilitiesPermissions.Delete);
export const editAssignmentAbility = makeMemberAbility('assignment', AbilitiesPermissions.Edit);
export const editAssignmentPaymentAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.Edit
);
export const editClientFilterAbility = makeMemberAbility(
  'client.client',
  AbilitiesPermissions.Edit
);
export const editGroupAbility = makeMemberAbility('assignment', AbilitiesPermissions.Edit);
export const editMemberAbility = makeMemberAbility('settings', AbilitiesPermissions.Edit);
export const editOrganizationConfigAbility = makeMemberAbility(
  'settings',
  AbilitiesPermissions.Edit
);
export const editParseCrewListAbility = makeMemberAbility('assignment', AbilitiesPermissions.Edit);
export const editParsePassengerListAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.Edit
);
export const editPartnerFilterAbility = makeMemberAbility(
  'client.partner',
  AbilitiesPermissions.Edit
);
export const editPartnerPaymentAbility = makeMemberAbility('client', AbilitiesPermissions.Edit);
export const editPortCallAbility = makeMemberAbility('assignment', AbilitiesPermissions.Edit);
export const editRecurringTransactionAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Edit
);
export const editReferralAbility = makeMemberAbility('referral', AbilitiesPermissions.Edit);
export const editRoleAbility = makeMemberAbility('settings', AbilitiesPermissions.Edit);
export const editSupplierFilterAbility = makeMemberAbility(
  'client.supplier',
  AbilitiesPermissions.Edit
);
export const editSupplierPaymentAbility = makeMemberAbility('client', AbilitiesPermissions.Edit);
export const editTaskAbility = makeScopedMemberAbility(
  ['task.own', 'task.all'],
  AbilitiesPermissions.Edit
);
export const editTaskAllAbility = makeMemberAbility('task.all', AbilitiesPermissions.Edit);
export const editTaskOwnAbility = makeMemberAbility('task.own', AbilitiesPermissions.Edit);
export const editTemplateAbility = makeMemberAbility('assignment', AbilitiesPermissions.Edit);
export const editTransactionAbility = makeMemberAbility('transaction', AbilitiesPermissions.Edit);
export const editTransactionPaymentAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.Edit
);
export const editVesselAbility = makeMemberAbility('vessel', AbilitiesPermissions.Edit);
export const viewActiveAssignmentsCountAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.View
);
export const viewArrivingVesselsCountAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.View
);
export const viewAssignmentAbility = makeMemberAbility('assignment', AbilitiesPermissions.View);
export const viewAssignmentPDFsAbility = makeMemberAbility('assignment', AbilitiesPermissions.View);
export const viewAssignmentPaymentAbility = makeMemberAbility(
  'assignment',
  AbilitiesPermissions.View
);
export const viewBalanceAbility = makeScopedMemberAbility(
  ['balance.own', 'balance.all'],
  AbilitiesPermissions.View
);
export const viewBalanceActivationAbility = makeScopedMemberAbility(
  ['balance.own', 'balance.all'],
  AbilitiesPermissions.View
);
export const viewBalanceAllAbility = makeMemberAbility('balance.all', AbilitiesPermissions.View);
export const viewBalanceMovementAbility = makeScopedMemberAbility(
  ['balance.own', 'balance.all'],
  AbilitiesPermissions.View
);
export const viewBalanceOwnAbility = makeMemberAbility('balance.own', AbilitiesPermissions.View);
export const viewCashflowAbility = makeMemberAbility('financial', AbilitiesPermissions.View);
export const viewClientBalanceAbility = makeMemberAbility('financial', AbilitiesPermissions.View);
export const viewClientFilterAbility = makeMemberAbility(
  'client.client',
  AbilitiesPermissions.View
);
export const viewExpensesAbility = makeMemberAbility('financial', AbilitiesPermissions.View);
export const viewGroupAbility = makeMemberAbility('assignment', AbilitiesPermissions.View);
export const viewIncomeAbility = makeMemberAbility('financial', AbilitiesPermissions.View);
export const viewMemberAbility = makeMemberAbility('settings', AbilitiesPermissions.View);
export const viewMemberImpersonateAbility = makeMemberAbility(
  'settings',
  AbilitiesPermissions.View
);
export const viewOfficeExpenseAbility = makeMemberAbility('transaction', AbilitiesPermissions.View);
export const viewOrganizationConfigAbility = makeMemberAbility(
  'settings',
  AbilitiesPermissions.View
);
export const viewOutstandingExpensesAbility = makeMemberAbility(
  'financial',
  AbilitiesPermissions.View
);
export const viewPartnerFilterAbility = makeMemberAbility(
  'client.partner',
  AbilitiesPermissions.View
);
export const viewPartnerPaymentAbility = makeMemberAbility('client', AbilitiesPermissions.View);
export const viewPortAbility = makeMemberAbility('assignment', AbilitiesPermissions.View);
export const viewPortCallAbility = makeMemberAbility('assignment', AbilitiesPermissions.View);
export const viewPortFiltersAbility = makeMemberAbility('assignment', AbilitiesPermissions.View);
export const viewRecurringTransactionAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.View
);
export const viewReferralAbility = makeMemberAbility('referral', AbilitiesPermissions.View);
export const viewRoleAbility = makeMemberAbility('settings', AbilitiesPermissions.View);
export const viewSupplierFilterAbility = makeMemberAbility(
  'client.supplier',
  AbilitiesPermissions.View
);
export const viewSupplierPaymentAbility = makeMemberAbility('client', AbilitiesPermissions.View);
export const viewTaskAbility = makeScopedMemberAbility(
  ['task.own', 'task.all'],
  AbilitiesPermissions.View
);
export const viewTaskAllAbility = makeMemberAbility('task.all', AbilitiesPermissions.View);
export const viewTaskOwnAbility = makeMemberAbility('task.own', AbilitiesPermissions.View);
export const viewTemplateAbility = makeMemberAbility('assignment', AbilitiesPermissions.View);
export const viewTransactionAbility = makeMemberAbility('transaction', AbilitiesPermissions.View);
export const viewTransactionPaymentAbility = makeMemberAbility(
  'transaction',
  AbilitiesPermissions.View
);
export const viewVesselAbility = makeMemberAbility('vessel', AbilitiesPermissions.View);

export const ResourcesAbilities = {
  assignments: {
    viewAbility: viewAssignmentAbility,
    deniedAbilityRules: [
      {
        ability: activeAssignmentFilterAbility,
        whenDenied: { status: { notIn: ['accepted', 'in_progress', 'finalising'] } },
        filter: true,
      },
    ],
  },
  balance_activations: {
    viewAbility: viewBalanceActivationAbility,
    scopes: [
      { ability: viewBalanceOwnAbility, scope: {} },
      { ability: viewBalanceAllAbility, scope: {} },
    ],
  },
  balance_holders: {
    viewAbility: viewBalanceAbility,
    scopes: [
      {
        ability: viewBalanceOwnAbility,
        scope: {
          query: {
            'balance_holders.kind': 'employee',
            'balance_holders.userId': '$session.userId',
          },
        },
      },
      { ability: viewBalanceAllAbility, scope: {} },
    ],
  },
  balance_movements: {
    viewAbility: viewBalanceMovementAbility,
    scopes: [
      {
        ability: viewBalanceOwnAbility,
        scope: {
          query: {
            'balance_movements.holderId': {
              in: {
                select: 'balance_holders.id',
                query: { kind: 'employee', userId: '$session.userId' },
              },
            },
          },
        },
      },
      { ability: viewBalanceAllAbility, scope: {} },
    ],
  },
  clients: {
    deniedAbilityRules: [
      { ability: viewClientFilterAbility, whenDenied: { type: { ne: 'client' } }, filter: true },
      { ability: viewPartnerFilterAbility, whenDenied: { type: { ne: 'partner' } }, filter: true },
      {
        ability: viewSupplierFilterAbility,
        whenDenied: { type: { ne: 'supplier' } },
        filter: true,
      },
    ],
  },
  payments: {
    deniedAbilityRules: [
      {
        ability: viewAssignmentPaymentAbility,
        whenDenied: { referenceType: { ne: 'assignment' } },
      },
      { ability: viewPartnerPaymentAbility, whenDenied: { referenceType: { ne: 'referral' } } },
      { ability: viewSupplierPaymentAbility, whenDenied: { referenceType: { ne: 'supplier' } } },
      {
        ability: viewTransactionPaymentAbility,
        whenDenied: { referenceType: { ne: 'transaction' } },
      },
    ],
  },
  port_calls: viewPortCallAbility,
  ports: viewPortAbility,
  recurring_transactions: viewRecurringTransactionAbility,
  referrals: viewReferralAbility,
  tasks: {
    viewAbility: viewTaskAbility,
    scopes: [
      {
        ability: viewTaskOwnAbility,
        scope: {
          query: {
            'tasks.id': {
              in: {
                select: 'assignees.referenceId',
                query: { referenceType: 'task', userId: '$session.userId' },
              },
            },
          },
        },
      },
      { ability: viewTaskAllAbility, scope: {} },
    ],
  },
  transactions: {
    viewAbility: viewTransactionAbility,
    deniedAbilityRules: [
      {
        ability: assignmentTransactionFilterAbility,
        whenDenied: { referenceType: { ne: 'assignment_invoice' } },
        filter: true,
      },
      { ability: viewOfficeExpenseAbility, whenDenied: { type: { ne: 'office_expense' } } },
    ],
  },
  vessels: viewVesselAbility,
} as const;
